import Collections from './Collections';

export default Collections;
